import * as React from 'react'

interface IUiKitProviderProps {
  children: React.ReactNode
}

export class UiKitProvider extends React.Component<IUiKitProviderProps> {
  componentDidMount() {
    window.document.addEventListener('keydown', this.keydown)
    window.document.addEventListener('mousedown', this.mousedown)
  }

  componentWillUnmount() {
    window.document.removeEventListener('keydown', this.keydown)
    window.document.removeEventListener('mousedown', this.mousedown)
  }

  keydown = () => window.document.body.classList && window.document.body.classList.remove('intent-mouse')

  mousedown = () => window.document.body.classList && window.document.body.classList.add('intent-mouse')

  render() {
    return this.props.children
  }
}

export function uiKitMiddleware() {
  return (props: { children: React.ReactNode }) => <UiKitProvider>{props.children}</UiKitProvider>
}
